import React from 'react';
import { Layout as LayoutTemplate, type LayoutProps } from '@tasama/ui';
import { useAuth } from '../hooks/use-auth';
import { env } from '../config/env';
import { EXTERNAL_ROUTES, FeatureFlags, isEnabled } from '@tasama/config';

export const Layout: React.FC = () => {
  const { error, errorType, clearError } = useAuth();

  const handleStartOnboardingClick = () => {
    // Navigate to onboarding application
    window.location.href = env.ONBOARDING_APP_BASE_URL;
  };

  const handleBackToWebsite = () => {
    window.location.href = EXTERNAL_ROUTES.TASAMA_WEBSITE;
  };

  // Layout configuration for the reusable Layout template
  const layoutConfig: LayoutProps = {
    variant: 'portal',
    navigation: {
      showLanguageSwitcher: isEnabled(FeatureFlags.LANGUAGE_SWITCHER),
      onBackToWebsite: handleBackToWebsite,
    },
    stepper: {
      onStartOnboarding: handleStartOnboardingClick,
    },
    error:
      error && errorType !== 'login'
        ? {
            show: true,
            data: {
              type: errorType === 'unauthorized' ? 'unauthorized' : 'error',
              message: error,
              onClear: clearError,
            },
          }
        : { show: false },
    layout: {
      maxWidth: 'max-w-[1600px]',
      padding: 'px-4 pt-5 md:px-8 md:pt-8 lg:px-[62px] lg:pt-6',
      showSidebar: true,
      showBottomNavigation: false,
    },
    testID: 'portal-layout',
  };

  return <LayoutTemplate {...layoutConfig} />;
};
